import { render, staticRenderFns } from "./confirmedWithdrawal.vue?vue&type=template&id=bf984634&scoped=true"
import script from "./confirmedWithdrawal.vue?vue&type=script&lang=js"
export * from "./confirmedWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./confirmedWithdrawal.vue?vue&type=style&index=0&id=bf984634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf984634",
  null
  
)

export default component.exports